import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DropdownButton, Dropdown, Form, Nav, Navbar, ListGroup, Spinner, Modal, Button } from 'react-bootstrap';
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoneVolume, faBackspace, faBuilding } from '@fortawesome/free-solid-svg-icons'
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
const LOGINURL = 'https://dzc9wj04g2.execute-api.ap-northeast-1.amazonaws.com/v2/login';
const AUTHURL = 'https://dzc9wj04g2.execute-api.ap-northeast-1.amazonaws.com/v2/auth';
const CALLURL = 'https://dzc9wj04g2.execute-api.ap-northeast-1.amazonaws.com/v2/call';
export const useDidMount = (func) => useEffect(() => { func() }, []);

document.addEventListener('touchmove', (event) => {
  if (event.scale !== 1) { event.preventDefault(); }
}, false);

let lastTouchEnd = 0;
document.addEventListener('touchend', (event) => {
  let now = (new Date()).getTime();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);

function App() {
  const [loginPhoneNumber, setLoginPhoneNumber] = useState('');
  const [code, setCode] = useState('');
  const [codeError, setCodeError] = useState('');
  const [callError, setCallError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [to, setTo] = useState('');
  const [showSpinner, setShowSpinner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [fromNumbers, setFromNumbers] = useState([]);
  const [callFrom, setCallFrom] = useState(null);
  const [callFromName, setCallFromName] = useState('');
  const [numberPad, setNumberPad] = useState('none');

  useDidMount(() => {
    const node = document.getElementById('phone');
    if (node !== null) {
      node.focus();
    }
    const node2 = document.getElementById('to');
    if (node2 !== null) {
      node2.focus();
    }
  });

  useEffect(() => {
    if (loginPhoneNumber) {
      setTimeout(() => {
      const node = document.getElementById('code');
      node.value = null;
      }, 300);
    }
  }, [loginPhoneNumber]);

  useEffect(() => {
    if (code) {
      const node = document.getElementById('to');
      if (node !== null) {
        node.focus();
      }
    }
  }, [code]);

  const handleUpdate = async (e) => {
    setShowSpinner(true);
    setPhoneError('');
    const tryPhoneNumber = document.getElementById('phone').value;
    if (tryPhoneNumber.length < 5) { setShowSpinner(false); return;}
    console.log(tryPhoneNumber);
    try {
      const phoneNumber = parsePhoneNumberFromString(tryPhoneNumber, 'JP');
      const loginRes = await axios.post(LOGINURL, {phone_number: phoneNumber.number});
      setLoginPhoneNumber(phoneNumber.number);
      setFromNumbers(loginRes.data);
      if (loginRes.data.length == 1) {
        setCallFrom(loginRes.data[0].call_from);
        setCallFromName(loginRes.data[0].name || '');
      }
      document.getElementById('phone').value = '';
    } catch(e) {
      setPhoneError('電話番号が違います');
    }
    setShowSpinner(false);
  };

  const handleCodeUpdate = async(e) => {
    setShowSpinner(true);
    setCodeError('');
    try {
      const tryCode = document.getElementById('code').value;
      const authRes = await axios.post(AUTHURL, {phone_number: loginPhoneNumber, code: tryCode});
      setCode(tryCode);
      document.getElementById('code').value = '';
    } catch(e) {
      setCodeError('確認コードが違います');
    }
    setShowSpinner(false);
  };

  const handleChange = async (e) => {
    if (e.key === 'Enter') {
      handleUpdate(e);
    }
  };

  const handleCode = async (e) => {
    if (e.key === 'Enter') {
      handleCodeUpdate(e);
    }
  };

  const handleButton = async (e) => {
    console.log(e.target.innerText);
    setTo(`${to}${e.target.innerText}`);
  };

  const handleCall = async () => {
    setCallError('');
    if (!callFrom) {
      setShowModal(false);
      setCallError('発信番号を選択してください');
      return;
    }
    let callTo;
    try {
      if (to === '都庁') {
        callTo = '+818054694667';
      } else {
        const phoneNumber = parsePhoneNumberFromString(to, 'JP');
        callTo = phoneNumber.number;
      }
      setShowModal(true);
      const callRes = await axios.post(CALLURL, {to: callTo, from: loginPhoneNumber, callFrom: callFrom, code: code});
    } catch(e) {
      setShowModal(false);
      setCallError('電話番号に誤りがあります');
    }
  };

  const handleDelete = () => {
    if (to) {
      let ar = to.split('');
      ar.pop();
      setTo(ar.join(''));
    }
  };

  //if (false) {
  if (!loginPhoneNumber) {
    return (
      <div className="App">
        <header className="App-header">
          {phoneError && <p className="Error">{phoneError}</p>}
          <p><b>あなたの</b>電話番号</p>
          {showSpinner && <Spinner animation="border" variant="info" size="sm" />}
          <input id="phone" type="tel" maxLength="20" className="Input-phone" defaultValue={""} onBlur={handleUpdate} onKeyPress={handleChange} /> 
        </header>
      </div>
    );
  } else if (!code) {
    return (
      <div className="App">
        <header className="App-header">
          <p>Slackに送信された確認コードを<br />こちらに記入してください</p>
          {codeError && <p className="Error">{codeError}</p>}
          <input id="code" maxLength="6" type="tel" className="Input-phone" defaultValue={""} onBlur={handleCodeUpdate} onKeyPress={handleCode} />
        </header>
      </div>
    );
  } else {
    return <div className="App">
<Navbar bg="primary" variant="dark">
  <Navbar.Brand href="#home">かんたん電話</Navbar.Brand>
  <Form inline>
    <DropdownButton id="dropdown-basic-button" title={callFrom ? `${callFromName} ${parsePhoneNumberFromString(callFrom, 'JP').formatNational()}` : '発信番号を選択'}>
      {fromNumbers.map((data, idx) => {
        return <Dropdown.Item onSelect={(e) => {
          setCallFrom(data.call_from);
          setCallFromName(data.name);
        }} key={`key-${idx}`}>{data.name} - {parsePhoneNumberFromString(data.call_from, 'JP').formatNational()}</Dropdown.Item>
      })}
  </DropdownButton>
  </Form>
</Navbar>
      <div>
        <input placeholder="発信先の電話番号" type="tel" id="to" className="Input-phone" onChange={(e) => {setTo(e.target.value);}} value={to} />
        {callError && <p className="Error">{callError}</p>}
      <div style={{textAlign:'center',marginTop:'40px',marginBottom:'40px'}}>
        <button className="dial" style={{fontSize:'36px'}} onClick={handleCall}>
          <FontAwesomeIcon style={{color:'green'}} icon={faPhoneVolume} />
        </button>
      </div>
      </div>
{false &&
      <div style={{textAlign:'center',marginTop:'40px',marginBottom:'40px'}}>
        {numberPad == 'none' &&
          <button className="btn btn-primary" onClick={() => {setNumberPad('block');}}>ダイアルを表示</button>
        }
        {numberPad == 'block' &&
          <button className="btn btn-primary" onClick={() => {setNumberPad('none');}}>ダイアルを隠す</button>
        }
      </div>
}
      <div style={{display:numberPad}}>
        <table>
          <tbody>
          <tr>
            <td><button className="dial" onClick={handleButton}>1</button></td>
            <td><button className="dial" onClick={handleButton}>2</button></td>
            <td><button className="dial" onClick={handleButton}>3</button></td>
          </tr>
          <tr>
            <td><button className="dial" onClick={handleButton}>4</button></td>
            <td><button className="dial" onClick={handleButton}>5</button></td>
            <td><button className="dial" onClick={handleButton}>6</button></td>
          </tr>
          <tr>
            <td><button className="dial" onClick={handleButton}>7</button></td>
            <td><button className="dial" onClick={handleButton}>8</button></td>
            <td><button className="dial" onClick={handleButton}>9</button></td>
          </tr>
          <tr>
            <td>{false && <button className="dial" onClick={() => {
              setTo('都庁');
            }}><FontAwesomeIcon icon={faBuilding} /></button>}</td>
            <td><button className="dial" onClick={handleButton}>0</button></td>
            <td></td>
          </tr>
          </tbody>
        </table>
        <div style={{display:'flex',marginTop:'10px'}}>
          <div style={{flex:'0.5',textAlign:'center'}}>
            <button className="dial" style={{fontSize:'36px'}} onClick={handleCall}>
              <FontAwesomeIcon style={{color:'green'}} icon={faPhoneVolume} />
            </button>
          </div>
          <div style={{flex:'0.5',textAlign:'center'}}>
            <button className="dial" style={{fontSize:'36px'}} onClick={handleDelete}>
              <FontAwesomeIcon style={{color:'red'}} icon={faBackspace} />
            </button></div>
        </div>
      </div>
      <Modal show={showModal}>
        <Modal.Header closeButton>
          <Modal.Title>通話を開始します</Modal.Title>
        </Modal.Header>
      
        <Modal.Body>
          <p>あなたの携帯電話を呼び出しています</p>
        </Modal.Body>
      
        <Modal.Footer>
          <Button onClick={() => {
            setShowModal(false);
          }} variant="primary">閉じる</Button>
        </Modal.Footer>
      </Modal>
    </div>
  }
}

export default App;
